/**
 * Propally Agent API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import UserSearchEnvelopeRequest from './UserSearchEnvelopeRequest';

/**
 * The BulkInvestmentProposalRequest model module.
 * @module model/BulkInvestmentProposalRequest
 * @version 1.0.0
 */
class BulkInvestmentProposalRequest {
    /**
     * Constructs a new <code>BulkInvestmentProposalRequest</code>.
     * @alias module:model/BulkInvestmentProposalRequest
     * @param targetType {module:model/BulkInvestmentProposalRequest.TargetTypeEnum} 対象の指定方法。チェック選択（user_ids）と検索条件（search）のいずれか。
     * @param proposalContent {String} 
     */
    constructor(targetType, proposalContent) { 
        
        BulkInvestmentProposalRequest.initialize(this, targetType, proposalContent);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj, targetType, proposalContent) { 
        obj['target_type'] = targetType;
        obj['proposal_content'] = proposalContent;
    }

    /**
     * Constructs a <code>BulkInvestmentProposalRequest</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/BulkInvestmentProposalRequest} obj Optional instance to populate.
     * @return {module:model/BulkInvestmentProposalRequest} The populated <code>BulkInvestmentProposalRequest</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new BulkInvestmentProposalRequest();

            if (data.hasOwnProperty('target_type')) {
                obj['target_type'] = ApiClient.convertToType(data['target_type'], 'String');
            }
            if (data.hasOwnProperty('user_ids')) {
                obj['user_ids'] = ApiClient.convertToType(data['user_ids'], ['Number']);
            }
            if (data.hasOwnProperty('search')) {
                obj['search'] = UserSearchEnvelopeRequest.constructFromObject(data['search']);
            }
            if (data.hasOwnProperty('proposal_content')) {
                obj['proposal_content'] = ApiClient.convertToType(data['proposal_content'], 'String');
            }
            if (data.hasOwnProperty('short_appeal_message')) {
                obj['short_appeal_message'] = ApiClient.convertToType(data['short_appeal_message'], 'String');
            }
            if (data.hasOwnProperty('proposal_date')) {
                obj['proposal_date'] = ApiClient.convertToType(data['proposal_date'], 'String');
            }
            if (data.hasOwnProperty('agent_message_template_id')) {
                obj['agent_message_template_id'] = ApiClient.convertToType(data['agent_message_template_id'], 'Number');
            }
            if (data.hasOwnProperty('replace_same_day')) {
                obj['replace_same_day'] = ApiClient.convertToType(data['replace_same_day'], 'Boolean');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>BulkInvestmentProposalRequest</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>BulkInvestmentProposalRequest</code>.
     */
    static validateJSON(data) {
        // check to make sure all required properties are present in the JSON string
        for (const property of BulkInvestmentProposalRequest.RequiredProperties) {
            if (!data[property]) {
                throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
            }
        }
        // ensure the json data is a string
        if (data['target_type'] && !(typeof data['target_type'] === 'string' || data['target_type'] instanceof String)) {
            throw new Error("Expected the field `target_type` to be a primitive type in the JSON string but got " + data['target_type']);
        }
        // ensure the json data is an array
        if (!Array.isArray(data['user_ids'])) {
            throw new Error("Expected the field `user_ids` to be an array in the JSON data but got " + data['user_ids']);
        }
        // validate the optional field `search`
        if (data['search']) { // data not null
          UserSearchEnvelopeRequest.validateJSON(data['search']);
        }
        // ensure the json data is a string
        if (data['proposal_content'] && !(typeof data['proposal_content'] === 'string' || data['proposal_content'] instanceof String)) {
            throw new Error("Expected the field `proposal_content` to be a primitive type in the JSON string but got " + data['proposal_content']);
        }
        // ensure the json data is a string
        if (data['short_appeal_message'] && !(typeof data['short_appeal_message'] === 'string' || data['short_appeal_message'] instanceof String)) {
            throw new Error("Expected the field `short_appeal_message` to be a primitive type in the JSON string but got " + data['short_appeal_message']);
        }
        // ensure the json data is a string
        if (data['proposal_date'] && !(typeof data['proposal_date'] === 'string' || data['proposal_date'] instanceof String)) {
            throw new Error("Expected the field `proposal_date` to be a primitive type in the JSON string but got " + data['proposal_date']);
        }

        return true;
    }


}

BulkInvestmentProposalRequest.RequiredProperties = ["target_type", "proposal_content"];

/**
 * 対象の指定方法。チェック選択（user_ids）と検索条件（search）のいずれか。
 * @member {module:model/BulkInvestmentProposalRequest.TargetTypeEnum} target_type
 */
BulkInvestmentProposalRequest.prototype['target_type'] = undefined;

/**
 * target_type=user_ids のとき使用
 * @member {Array.<Number>} user_ids
 */
BulkInvestmentProposalRequest.prototype['user_ids'] = undefined;

/**
 * @member {module:model/UserSearchEnvelopeRequest} search
 */
BulkInvestmentProposalRequest.prototype['search'] = undefined;

/**
 * @member {String} proposal_content
 */
BulkInvestmentProposalRequest.prototype['proposal_content'] = undefined;

/**
 * @member {String} short_appeal_message
 */
BulkInvestmentProposalRequest.prototype['short_appeal_message'] = undefined;

/**
 * 未来日時の場合は予約送信予定日時。未指定または現在以前の場合は即時送信。
 * @member {String} proposal_date
 */
BulkInvestmentProposalRequest.prototype['proposal_date'] = undefined;

/**
 * 本文の元にしたメッセージテンプレートの ID（テンプレート別分析用）。テンプレート未使用の場合は未指定。
 * @member {Number} agent_message_template_id
 */
BulkInvestmentProposalRequest.prototype['agent_message_template_id'] = undefined;

/**
 * true かつ proposal_date が未来日時のとき、同一ユーザー宛てで同じ暦日（JST）に入っている送信予約を取り消してから登録する（送信待ちの提案があるユーザーも skipped にせず置き換える）。
 * @member {Boolean} replace_same_day
 * @default false
 */
BulkInvestmentProposalRequest.prototype['replace_same_day'] = false;





/**
 * Allowed values for the <code>target_type</code> property.
 * @enum {String}
 * @readonly
 */
BulkInvestmentProposalRequest['TargetTypeEnum'] = {

    /**
     * value: "user_ids"
     * @const
     */
    "user_ids": "user_ids",

    /**
     * value: "search"
     * @const
     */
    "search": "search"
};



export default BulkInvestmentProposalRequest;

